var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "chart-section" }, [
    _c("div", { staticClass: "chart-section__inner" }, [
      _c(
        "svg",
        { staticClass: "chart", attrs: { viewBox: "0 0 448 448" } },
        [
          _c(
            "linearGradient",
            {
              attrs: {
                id: "strokeGradient",
                x1: "1",
                y1: "0",
                x2: "0.2",
                y2: "0"
              }
            },
            [
              _c("stop", {
                staticStyle: { "stop-color": "#f7be01" },
                attrs: { offset: "0" }
              }),
              _vm._v(" "),
              _c("stop", {
                staticStyle: { "stop-color": "#178100" },
                attrs: { offset: "1.0" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("circle", {
            staticClass: "chart-ring",
            attrs: {
              cx: "224",
              cy: "224",
              r: "210",
              fill: "transparent",
              stroke: "#eaeaea",
              "stroke-width": "28"
            }
          }),
          _vm._v(" "),
          _c("circle", {
            staticClass: "chart-segment chart-ring center",
            attrs: {
              "data-per": "50",
              cx: "224",
              cy: "224",
              r: "210",
              fill: "transparent",
              "stroke-width": "28",
              "stroke-dasharray": "0 0",
              stroke: "url(#strokeGradient)",
              "stroke-linecap": "round"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "box-chart-data" }, [
        _c("div", { staticClass: "chart-txt" }, [_vm._v("달성 조")]),
        _vm._v(" "),
        _c("div", { staticClass: "chart-data" }, [
          _vm._v(_vm._s(_vm.attainmentlevel))
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "chart-button",
            attrs: { type: "button", "data-layer": "aboPopup" },
            on: {
              click: function($event) {
                return _vm.$emit("layer", "aboPopup")
              }
            }
          },
          [_vm._v("달성조건 보기")]
        )
      ])
    ]),
    _vm._v(" "),
    _vm.attainmentlevel >= 10
      ? _c("div", { staticClass: "goal-box" }, [
          _c("h4", { staticClass: "goal-box__title" }, [
            _vm._v(
              _vm._s(_vm.attainmentmonth) + "월 목표 달성에 성공하셨습니다!"
            )
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "goal-box__link",
              attrs: { href: "https://www.amway.co.kr/my-account/money" }
            },
            [_vm._v("A Cliks Money 관리")]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "goal-box__description" }, [
      _c("span", { staticClass: "clicks-img" }, [
        _c("span", { staticClass: "hidden" }, [_vm._v("Clicks Money")])
      ]),
      _vm._v("\n      지급에 대한 내용은 추후 "),
      _c("br"),
      _vm._v("맞춤메시지를 통해 안내 드리도록 하겠습니다.\n    ")
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5961b9cd", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5961b9cd","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/sales/dashboard/component/attainment.vue
// module id = null
// module chunks = 